import { useParams } from 'react-router-dom';
import { AgencyDetailsModel, useGetAgencyDetails } from '@urbanx/agx.agencies.client';

const useSelectedAgency = (): {
  agency?: AgencyDetailsModel;
  isLoading: boolean;
  isFetched: boolean;
} => {
  const { agencyId } = useParams();

  const { data: agency, isPending } = useGetAgencyDetails(agencyId!, !!agencyId);

  return {
    agency,
    isLoading: isPending,
    isFetched: agency !== undefined && !isPending,
  };
};

export default useSelectedAgency;
